import { ServiceProviderCategoryEnum } from '../../../../../lib/graphql'

export const getHouseProvisionsSectionTitle = (
  category: ServiceProviderCategoryEnum,
) => {
  switch (category) {
    case ServiceProviderCategoryEnum.HOUSE:
      return 'Prestations du lieu'
    case ServiceProviderCategoryEnum.BATCH_PROVISIONS:
      return 'Forfaits disponibles'
    case ServiceProviderCategoryEnum.ACTIVITY:
      return 'Activités du lieu'
    case ServiceProviderCategoryEnum.TRANSPORT:
      return 'Transports du lieu'
    case ServiceProviderCategoryEnum.RESTAURATION:
      return 'Restauration du lieu'
    default:
      return ''
  }
}
